import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

function ServiceCard({ id, title, desc, icon }) {
  return (
    <motion.div 
      whileHover={{ y: -12 }}
      className="group bg-white p-10 rounded-[2.5rem] border border-gray-100 shadow-sm hover:shadow-2xl hover:shadow-blue-100 transition-all duration-500"
    >
      <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center text-4xl mb-8 group-hover:bg-blue-600 group-hover:rotate-[360deg] transition-all duration-700">
        {icon}
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors">
        {title}
      </h3>
      <p className="text-gray-500 leading-relaxed font-medium mb-8">
        {desc}
      </p>
      
      {/* Learn More Link jo Detailed Page par le jaye ga */}
      <Link 
        to={`/services/${id}`} 
        className="inline-flex items-center text-blue-600 font-bold text-sm hover:underline"
      >
        Learn More <span className="ml-2">→</span>
      </Link>
    </motion.div>
  );
}

export default ServiceCard; // Ye line sabse zaroori hai!